// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"c549bfe0","627":"9b8ee539","787":"9bbe4c28","915":"19e78b24"}[chunkId] + ".chunk.js";
};